import { LangText } from '@/components'
import { handleClick } from '@/components/OutLink'
import { JAPAN_MALL_URL } from '@/constants'
import { PlatformEnum } from '@/service/api/types'
import { preFixImgUrl } from '@/utils'
import arrowRight from '@/assets/svg/arrow-right.svg'

const CTA_BACKGROUND =
  'd2a0f01af9fd19031fa69e351fa618bd.png'

const QUICK_LINKS = [
  {
    icon: '5847681043812ec3a674e659a632a050.png',
    labelKey: 'hanedaShop.cta.links.terms',
    href: `${JAPAN_MALL_URL}/special?id=135`,
  },
  {
    icon: '0ceff1a011a11def27d760639f8bb247.png',
    labelKey: 'hanedaShop.cta.links.precautions',
    href: `${JAPAN_MALL_URL}/special?id=132&storeId=17`,
  },
  {
    icon: 'c9d2a161abe51e1eaf51cd4b1bbd8186.png',
    labelKey: 'hanedaShop.cta.links.faq',
    href: `${JAPAN_MALL_URL}/special?id=126`,
  },
  {
    icon: 'f5395a06c1bdd6471e4b11ad065722c4.png',
    labelKey: 'hanedaShop.cta.links.contact',
    href: 'mailto:info.japanmall@jdxjp.net',
  },
] as const

const ShoppingCta = () => {
  const bookNow = () => {
    return handleClick({
      platform: PlatformEnum.JAPANMALL,
      linUrl: JAPAN_MALL_URL,
    })
  }

  return (
    <section className="overflow-hidden relative w-full group" style={{ height: 480 }}>
      <div
        className="absolute inset-0 bg-center bg-no-repeat bg-cover transition-transform duration-700 ease-out group-hover:scale-105"
        style={{ backgroundImage: `url(${preFixImgUrl(CTA_BACKGROUND)})` }}
        aria-hidden
      />

      <div className="relative z-[1] mx-auto flex h-full w-[1200px] flex-col items-center pt-[72px] text-white">
        <LangText
          lngKey="hanedaShop.cta.title"
          className="text-[36px] font-bold leading-[50px]"
        />
        <LangText
          lngKey="hanedaShop.cta.description"
          className="mt-[16px] text-[28px] leading-[40px]"
        />

        <button
          type="button"
          onClick={bookNow}
          className="mt-[32px] h-[48px] cursor-pointer rounded-full bg-white px-[30px] text-[20px] font-medium text-primary transition-[transform,box-shadow] duration-300 hover:scale-105 hover:shadow-[0_10px_24px_rgba(0,0,0,0.16)]"
        >
          <LangText lngKey="hanedaShop.cta.bookNow" />
        </button>

        <nav className="mt-[76px] grid h-[80px] w-[1120px] grid-cols-4 overflow-hidden rounded-full border border-white/40 bg-white/15 backdrop-blur-[8px]">
          {QUICK_LINKS.map((item) => {
            const isMailLink = item.href.startsWith('mailto:')

            return (
              <a
                key={item.labelKey}
                href={item.href}
                {...(isMailLink ? {} : { target: '_blank', rel: 'noopener noreferrer' })}
                onClick={isMailLink ? undefined : (event) => {
                  event.preventDefault()
                  void handleClick({
                    platform: PlatformEnum.JAPANMALL,
                    linUrl: item.href,
                  })
                }}
                className="group/link flex items-center justify-center gap-[12px] rounded-full text-[20px] transition-colors duration-300 first:pl-[24px] last:pr-[24px] hover:bg-white/15"
              >
                <img
                  src={preFixImgUrl(item.icon)}
                  alt=""
                  className="h-[40px] w-[40px] object-contain transition-transform duration-300 group-hover/link:scale-110"
                  aria-hidden
                />
                <LangText lngKey={item.labelKey} />
                <img
                  src={arrowRight}
                  alt=""
                  className="h-[14px] w-[14px] object-contain transition-transform duration-300 group-hover/link:translate-x-[2px]"
                  aria-hidden
                />
              </a>
            )
          })}
        </nav>
      </div>
    </section>
  )
}

export default ShoppingCta
